

import React from 'react'
import styled from 'styled-components'
import { Tooltip } from 'antd'


const EllipsisTooltipView = styled.div`
  word-break: keep-all;
  text-overflow: ellipsis;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  .hide-text{
    position: absolute;
    visibility: hidden;
  }
`


interface EllipsisTooltipProps {
  text: string
  width?: number
}




export const EllipsisTooltip = (props: EllipsisTooltipProps) => {
  const { text ,width} = props
  const hideTextRef = React.useRef<HTMLDivElement>(null)
  const containerRef = React.useRef<HTMLDivElement>(null)
  const [isEllopsis, setIsEllipsis] = React.useState(false)
  React.useEffect(() => {
    let textWidth = hideTextRef.current?.clientWidth || 0
    let containerWidth = containerRef.current?.clientWidth || 0
    let isEllopsis = textWidth > containerWidth
    setIsEllipsis(isEllopsis);
  }, [text, width])
  const content = <EllipsisTooltipView ref={containerRef}>
    {text}
    <div className='hide-text' ref={hideTextRef}>{text}</div>
  </EllipsisTooltipView>

  return isEllopsis ? <Tooltip title={text}>{content}</Tooltip> : content
}